import { render, staticRenderFns } from "./ServiceRequestDetails.vue?vue&type=template&id=a81d8510&scoped=true&"
import script from "./ServiceRequestDetails.vue?vue&type=script&lang=js&"
export * from "./ServiceRequestDetails.vue?vue&type=script&lang=js&"
import style0 from "./ServiceRequestDetails.vue?vue&type=style&index=0&id=a81d8510&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81d8510",
  null
  
)

export default component.exports